/* SB Mengenrechner — vanilla JS, no deps */
(function () {
  function init(root) {
    var area = root.querySelector('[data-area]');
    var depth = root.querySelector('[data-depth]');
    var mat = root.querySelector('[data-material]');
    var waste = root.querySelector('[data-waste]');
    var resultEl = root.querySelector('[data-result]');
    var bagsEl = root.querySelector('[data-bags]');

    function fmt(n) { return n.toLocaleString(document.documentElement.lang || 'de', { maximumFractionDigits: 0 }); }

    function recompute() {
      var a = parseFloat(area.value) || 0;
      var d = (parseFloat(depth.value) || 0) / 100; // cm -> m
      var density = parseFloat(mat.value) || 1.6;   // t/m³
      var kg = a * d * density * 1000;
      if (waste && waste.checked) kg *= 1.10;
      var rounded = Math.ceil(kg);
      resultEl.textContent = fmt(rounded);
      if (bagsEl) bagsEl.textContent = fmt(Math.ceil(rounded / 20));
    }

    [area, depth, mat, waste].forEach(function (el) {
      if (el) el.addEventListener('input', recompute);
      if (el) el.addEventListener('change', recompute);
    });
    recompute();
  }

  document.querySelectorAll('[data-sb-calc]').forEach(init);
})();
